<template>
  <div class="report" v-loading="loading">
    <div class="title">
      <div class="sort">
        <div class="border-left">
          <span>已通过</span>
          <br />
          <P>{{statusCount.pass || 0}}个</P>
        </div>
      </div>
      <div class="sort">
        <div class="border-left">
          <span>已驳回</span>
          <br />
          <P>{{statusCount.reject || 0}}个</P>
        </div>
      </div>
      <div class="sort">
        <div class="border-left">
          <span>本周完成数</span>
          <br />
          <P>{{statusCount.total || 0}}个</P>
        </div>
      </div>
    </div>
    <div class="content">
      <d-search
        class="d-search"
        :searchData="searchData"
        @searchEvent="searchEvent"
        @openEvent="openEvent"
        @exportEvent="exportEvent"
      />

      <d-lable :columnData="columnData" :tableData="tableData" @viewEvent="viewEvent"></d-lable>
      <d-paging :pager="pager" @change="getItemList" />
    </div>
  </div>
</template>

<script>
import DSearch from "../../../components/d-search";
import DLable from "../../../components/d-table";
import DPaging from "../../../components/d-paging";
import { options } from "../../../components/options";
import { onDownload } from "@/utils/utils";
export default {
  data() {
    return {
      pager: {
        count: 0,
        page: 1,
        rows: 10
      },
      loading: true,
      statusCount: {
        reject: null,
        pass: null,
        total: null
      },
      searchData: {
        searchItem: [
          {
            label: "状态",
            value: "status",
            type: "commonSelect",
            placeholder: "",
            options: []
          },
          {
            label: "选择店铺",
            value: "shopIdList",
            type: "linkageSelect",
            dateType: "month",
            placeholder: "",
            options: options,
            optionProps: {
              value: "name",
              label: "name",
              children: "childList"
            }
          }
        ],
        searchBtn: {
          queryBtn: true,
          exportBtn: true,
          isOpen: {
            type: true,
            open: true
          }
        },
        params: {
          status: null
        }
      },
      columnData: [
        { prop: "id", label: "编号" },
        { prop: "floor", label: "楼层" },
        { prop: "shopNo", label: "店铺号" },
        { prop: "shopName", label: "店铺名称" },
        { prop: "outValidity", label: "出门有效期", width: 90 },
        { prop: "status", label: "状态" },
        { prop: "commitUser", label: "提交人" },
        { prop: "createTime", label: "提交时间", width: "200" },
        {
          prop: "operate",
          label: "操作",
          type: {
            viewBtn: true
          }
        }
      ],
      tableData: [],
      flootList: []
    };
  },
  computed: {},
  components: {
    DSearch,
    DLable,
    DPaging
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    /**
     * 搜索按钮点击
     */
    searchEvent() {
      this.accessPermissionList();
    },
    /**
     * 展开收起按钮
     */
    openEvent(status) {
      this.searchData.searchBtn.isOpen.open = status;
      if (!this.searchData.searchBtn.isOpen.open) {
        const floot = {
          label: "楼层",
          value: "floot",
          type: "commonSelect",
          placeholder: "",
          options: this.flootList
        };
        this.searchData.searchItem.push(floot);
      } else {
        this.searchData.searchItem = this.searchData.searchItem.slice(0, 2);
      }
    },
    /**
     * 获取状态列表
     */
    getStatusList() {
      this.$api.sysapi
        .getStatusList({ dictType: "report_status" })
        .then(({ code, data }) => {
          this.searchData.searchItem[0].options = data.list.map(item => ({
            value: item.dictValue,
            label: item.dictLabel
          }));
        });
    },
    /**
     * 获取楼层列表
     */
    getFloorList() {
      this.$api.sysapi.getfloorList().then(({ code, data }) => {
        if (code === 200) {
          this.flootList = data.map(item => ({
            value: item.id,
            label: item.name
          }));
        }
      });
    },
    /**
     * 查询请求
     */
    getItemList() {
      this.accessPermissionList();
    },
    /**
     * 获取选择店铺列表
     */
    getShopList() {
      this.$api.shopapi.getShopList().then(({ data, code }) => {
        if (code == 200) {
          this.childList = data.childList;
          const child = [
            {
              id: data.id,
              name: data.name,
              childList: data.childList
            }
          ];
          this.searchData.searchItem.forEach(item => {
            if (item.type === "linkageSelect") {
              item.options = child;
            }
          });
        }
      });
    },
    /**
     * 列表查看btn
     */
    viewEvent(column) {
      this.$router.push({
        path: "/statement/outAllowInfo",
        query: { id: column.id }
      });
    },
    /**
     * 出入许可列表
     */
    accessPermissionList() {
      const obj = {
        pageNum: this.pager.page,
        pageSize: this.pager.rows,
        status: this.searchData.params.status,
        shop: this.searchData.params.shopIdList
          ? this.searchData.params.shopIdList[
              this.searchData.params.shopIdList.length - 1
            ]
          : null,
        floor: this.searchData.params.floot
      };
      this.$api.checkapi
        .accessPermissionList(obj)
        .then(({ code, data, msg }) => {
          this.loading = false;
          if (code === 200) {
            this.pager.count = data.total;
            this.tableData = data.list.map(item => ({
              ...item,
              sex: item.sex === "F" ? "女性" : item.sex === "M" ? "男性" : "无",
              status:
                item.status === 0
                  ? "驳回"
                  : item.status === 1
                  ? "通过"
                  : item.status === 2
                  ? "待审核"
                  : "错误状态"
            }));
          } else {
            this.$message.error(msg);
          }
        });
    },
    /**
     * 导出
     */
    exportEvent() {
      const obj = {
        status: this.searchData.params.status,
        shop: this.searchData.params.shopIdList
          ? this.searchData.params.shopIdList[
              this.searchData.params.shopIdList.length - 1
            ]
          : null,
        floor: this.searchData.params.floot
      };
      this.$api.mentapi.accessPermissionExport(obj).then(res => {
        let { headers, data } = res;
        onDownload(headers, data);
      });
    },
    /**
     * 获取上报销售信息
     */
    getAccessPermissionInfo() {
      this.$api.mentapi.getAccessPermissionInfo().then(({ data, code }) => {
        if (code === 200) {
          this.statusCount = data;
        }
      });
    },
    /**
     * init 初始化
     */
    init() {
      this.getShopList();
      this.getStatusList();
      this.getFloorList();
      this.getAccessPermissionInfo();
      this.accessPermissionList();
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
.report {
  width: 100%;
  .title {
    width: 100%;
    height: 105px;
    background-color: #fff;
    display: flex;
    .sort:nth-child(-n + 2) {
      .border-left {
        border-right: 1px solid #ccc;
      }
    }
    .sort {
      width: 33.33%;
      height: 100%;
      text-align: center;
      .border-left {
        margin-top: 20px;
        span {
          display: inline-block;
          font-weight: 400;
          font-style: normal;
          color: #999999;
        }
        p {
          display: inline-block;
          font-weight: 400;
          font-style: normal;
          font-size: 24px;
          color: #1b1b1b;
          margin-top: 10px;
        }
      }
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    height: calc(100% - 105px);
    width: 100%;
    margin-top: 20px;
    box-sizing: border-box;
    background-color: #fff;
    padding: 0 30px;
    text-align: center;
    .d-search {
      padding: 30px 0;
    }
    .el-table {
      margin-bottom: 20px;
      flex: 1;
      overflow-y: auto;
    }
  }
}
</style>
